"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserConnectionObserver = exports.ConnectionObserver = void 0;
var tslib_1 = require("tslib");
var emitter_1 = require("@spotify-internal/emitter/es5");
var event_1 = require("../enums/event");
var ConnectionObserver = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectionObserver, _super);
    function ConnectionObserver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConnectionObserver;
}(emitter_1.EventEmitter));
exports.ConnectionObserver = ConnectionObserver;
var BrowserConnectionObserver = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserConnectionObserver, _super);
    function BrowserConnectionObserver(options) {
        var _this = _super.call(this) || this;
        var hasWindow = typeof window !== 'undefined';
        var notifyBeforeUnload = options && options.notifyBeforeUnload;
        _this._navigator = (hasWindow && window.navigator) || null;
        if (hasWindow && typeof window.addEventListener === 'function') {
            window.addEventListener('online', _this.emitSync.bind(_this, event_1.Event.CONNECTION_ONLINE, null));
            window.addEventListener('offline', _this.emitSync.bind(_this, event_1.Event.CONNECTION_OFFLINE, null));
            if (notifyBeforeUnload) {
                window.addEventListener(event_1.Event.WINDOW_BEFORE_UNLOAD, _this.emitSync.bind(_this, event_1.Event.WINDOW_BEFORE_UNLOAD, null));
            }
        }
        return _this;
    }
    BrowserConnectionObserver.create = function (options) {
        return new BrowserConnectionObserver(options);
    };
    BrowserConnectionObserver.prototype.isOnline = function () {
        var navigator = this._navigator;
        if (navigator && 'onLine' in navigator) {
            return navigator.onLine;
        }
        return true;
    };
    return BrowserConnectionObserver;
}(ConnectionObserver));
exports.BrowserConnectionObserver = BrowserConnectionObserver;
//# sourceMappingURL=connection_observer.js.map